/**
 * SuppliersPage Component
 *
 * Page wrapper for the Suppliers management functionality.
 * Renders the SuppliersList component with page header.
 *
 * User Story: US-P6-001 - Inventory Management
 * Step 1: Suppliers Management
 */

import { PageLayout } from '@/components/layout'
import SuppliersList from '@/components/inventory/SuppliersList'

export default function SuppliersPage({ user, onLogout }) {
  return (
    <PageLayout user={user} onLogout={onLogout}>
      <div className="space-y-6">
        {/* Page Header */}
        <div>
          <h1 className="text-2xl font-semibold text-slate-900">Suppliers</h1>
          <p className="text-sm text-slate-600 mt-1">
            Manage your material suppliers and their contact information.
          </p>
        </div>

        {/* Suppliers List */}
        <SuppliersList />
      </div>
    </PageLayout>
  )
}
